import { orderSections } from '@/components/views/DynamicPageView/config/shared/orderSections';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { WIDGETS } from '@/components/views/DynamicPageView/config/shared/widgets';
import { ALL_CORE_APP_ROLES, APP_ROLES } from '@/config/config';
import { ApplicationType, PageScheme } from '@/config/types';

export const PAGE_PAY_BY_LINK: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.PAY_BY_LINK,
  showIfAllowedProduct: ApplicationType.PAY_BY_LINK,
  schemesByRoles: [
    {
      roles: [...ALL_CORE_APP_ROLES],
      titleTextId: 'PAY_BY_LINK_DETAIL',
      widgets: [
        { id: WIDGETS.LOAN_PARTICIPANT_SOURCE_WIDGET, roles: [...ALL_CORE_APP_ROLES], props: {} },
        {
          id: WIDGETS.LOAN_DETAIL_ACTIONS,
          roles: [
            APP_ROLES.ADMIN,
            APP_ROLES.SUPER_ADMIN,
            APP_ROLES.MERCHANT,
            APP_ROLES.CHANNEL,
            APP_ROLES.AGENT,
            APP_ROLES.CPC_BACK_OFFICE,
          ],
          props: {},
        },
        {
          id: WIDGETS.OPEN_APPLICATION,
          roles: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN],
          props: { application: ApplicationType.PAY_BY_LINK },
        },
        {
          id: WIDGETS.LOAN_HIGHLIGHTS,
          roles: [...ALL_CORE_APP_ROLES],
          props: {},
        },
        { id: WIDGETS.LOAN_PAGE_TITLE, roles: [...ALL_CORE_APP_ROLES], props: {}, notShownInRightMenu: true },
      ],
    },
  ],
  sections: orderSections,
};
